import React from 'react';

const SectionTitle = ({ count = 0, text = '' }) => {
    return (
        <div className="w-full flex items-center border border-[#253B7E] bg-white rounded-full p-2 md:p-4 shadow-md">
            <div className="text-white bg-[#F60362] rounded-full w-10 h-10 md:w-14 md:h-14 min-w-[40px] flex justify-center items-center font-bold text-lg md:text-2xl mr-2 md:mr-4">
                {count}
            </div>
            <p className="text-lg md:text-xl text-[#253B7E] font-bold">{text}</p>
        </div>
    );
};

export default SectionTitle;